export class RoundAndClinicModel {
    patientcode = '';
    notetype = '';
    note = '';
    date = '';
    extra = '';
    userid = '';
    compcode = '';


}
